import React, { useState, useEffect, useRef } from "react";
import { Button } from "primereact/button";
import TranslationFile from "../../Pages/15-Translation/locale/Translation_apps.json";
import { previewPdfOnSamePage } from "../../Component/commonUtils";
import { Dialog } from "primereact/dialog";
import PreviewPdfLoadingGif from "../../Assests/PreviewPdfLoading.gif";

export default function PreviewPdfHeader(props) {
  let userSelectedLanguage = localStorage.getItem("selectedLanguage");

  const [pdfLoading, setPdfLoading] = useState(false);
  const [pdfDialogBox, setPdfDialogBox] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);

  console.log(props, "@@ POS", props.arrowPosition);

  const test = async (currentReportGUIDFromUrl) => {
    if (props.onBeforePreview) {
      const shouldContinue = await props.onBeforePreview();
      if (shouldContinue === false) {
        return;
      }
    }

    setPdfDialogBox(true);
    setPdfLoading(true);
    const runPreview = async () => {
      const reportUrl = await previewPdfOnSamePage(currentReportGUIDFromUrl);
      console.log(reportUrl, " ** URL");
      setPdfUrl(reportUrl);
      setPdfLoading(false);
    };

    runPreview();
  };

  const handleChange = () => {
    props.onButtonClick();
  };

  const dialogBoxOnHide = () => {
    setPdfDialogBox(false);
    setPdfLoading(false);
    setPdfUrl(null);
  };

  return (
    <div>
      <Button
        type="button"
        icon="pi pi-file-pdf"
        outlined
        style={{ borderRadius: "70px" }}
        className="pdf_view_incomestatement"
        tooltip={TranslationFile.pdfPreview[userSelectedLanguage]}
        tooltipOptions={{ position: "bottom" }}
        onClick={() => test(props.reportGuid)}
      />

      {props.arrowPosition != undefined && (
        <div className="ISExapndCollapsToggleLbl">
          <Button
            value={props.arrowPosition}
            icon={
              props.arrowPosition ? "pi pi-chevron-down" : "pi pi-chevron-up"
            }
            title="Expand"
            onClick={(e) => handleChange(props.arrowPosition)}
            className="toggle-open"
          />
        </div>
      )}

      <Dialog
        visible={pdfDialogBox}
        header={TranslationFile.pdfPreview[userSelectedLanguage]}
        modal
        blockScroll
        className="previewPdfHeaderDialogBox"
        onHide={() => dialogBoxOnHide()}
      >
        <div>
          <center>
            <div className="review-iframe-div">
              {pdfLoading ? (
                <>
                  <img
                    src={PreviewPdfLoadingGif}
                    alt="loading..."
                    style={{
                      width: "14em",
                      height: "14em",
                      marginTop: "1em"
                    }}
                    className="companyInfoProceedSpinner"
                  />
                  <p>
                    <i>
                      {TranslationFile.previewPdfLoading[userSelectedLanguage]}
                    </i>
                  </p>
                </>
              ) : (
                pdfUrl &&
                pdfUrl.length > 0 && (
                  <iframe
                    src={pdfUrl + "#toolbar=0&navpanes=0&scrollbar=0"}
                    className="review-iframe"
                  ></iframe>
                )
              )}
            </div>
          </center>
        </div>
      </Dialog>
    </div>
  );
}
